module.exports = __webpack_public_path__ + "img/desc-2.2.8582fe08.jpg";